import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelUe.mjs'
import SrcType from '../components/SrcType.mjs'
import UeType from './UeType.mjs'
import ButtonMakeSf from './PropertiesPaneButtonMakeSf/PropertiesPaneButtonMakeSf.jsx'

const PropertiesPaneUe = (props) => (
    <ComponentPropertiesPane
        //buttons={
            //<>
                //<ButtonMakeSf />
            //</>
        //}

        controllers={
            <>
                <Text
                    label="界面名称"
                    prop="uiName"
                    readOnly
                />

                <Text prop="ueName" />
                <Text prop="ueUserCode" />

                <Select
                    allowClear={false}
                    options={UeType}
                    prop="ueTypeCode"
                />

                <Select
                    options={SrcType}
                    prop="srcType"
                />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    //'Depend',
                    'Effect',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneUe
